// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sidebar_wrapper__30YwD","active":"sidebar_active__1hKx5","navItem":"sidebar_navItem__1ifM9","name":"sidebar_name__358xO","dot":"sidebar_dot__3jVDq"};